import { styled } from '@mui/system';

export const StyledLabel = styled('div')(({ theme }) => ({
  marginTop: '12px',
  fontWeight: 550,
  color: theme.palette.label.default,
}));
